const ITEMS = [
  "LAUNCH WHERE YOU LAND.",
  "TALENT IS UNIVERSAL. VISIBILITY IS NOT.",
  "200M+ CONNECTED TV HOMES",
  "REAL PLACES. REAL PEOPLE. REAL CULTURE.",
  "193 COUNTRIES",
  "START WHERE YOU ARE. BE SEEN EVERYWHERE.",
  "ROKU · APPLE TV · FIRE TV · SAMSUNG TIZEN · LG WEBOS",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className={`font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight whitespace-nowrap px-8 ${i % 2 === 0 ? "text-white" : "text-outline"}`}>
          {item}
        </span>
        <span className="h-2 w-2 rounded-full bg-signal shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      aria-hidden
      className="relative py-10 border-y border-white/10 bg-charcoal/60 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        <Strip />
        <Strip />
      </div>
    </section>
  );
}
